<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createRestaurant" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>
                <div v-html="item.description_th"></div>
              </td>
              <td>
                <div v-html="item.description_en"></div>
              </td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showRestaurantData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "RestaurantTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch },
  data() {
    return {
      title: "Restaurant",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Description TH" },
        { id: 4, text: "Description EN" },
        { id: 5, text: "Update date" },
        { id: 6, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getRestaurantTable(1);
  },
  methods: {
    goToRestaurantEdit() {
      this.$router.push("/restaurant/edit");
    },
    getRestaurantTable(page) {
      this.$store.dispatch("Restaurant/getRestaurant", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("Restaurant/getRestaurant", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    showRestaurantData(id) {
      this.$store.dispatch("Restaurant/showRestaurant", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Restaurant/setFormRestaurant", res.result).then(() => {
            this.goToRestaurantEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createRestaurant() {
      this.$store.dispatch("Restaurant/clearFormData").then(() => {
        this.goToRestaurantEdit();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables.scss";

.branch-data {
  background-color: $background-theme;
  margin: $margin-search;
}
</style>
